<template>
    <div>
        <tsoft-table
            :key="componentRefreshKey"
            :api="tableApiUrl"
            :items.sync="items"
            :isNeedSearch="true"
            :additionalGetParameter="additionalGetParameter"
            :isNeedCreate="isNeedCreate && noDebt()"
            :typeOfTableFilter="typeOfTableFilter"
            :onDataEmptyMessage="'Платежи отсутствуют. Создайте счет в заказе, и добавьте к нему платежи.'"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
        />

        <div v-if="isNeedSubtotal">
            <hr style="margin-top: 0;">
            <div class="text-right">
                Сумма счета: <b>{{ sumRubles | toCurrency }} р.</b><br>
                Всего оплачено: <b>{{ allPaidSummer('sum') | toCurrency }} р.</b><br>
                Всего должны: <b>{{ (sumRubles - allPaidSummer('sum')) | toCurrency }} р.</b><br>
            </div>
        </div>

        <b-sidebar
            v-if="isSidebarOpen"
            v-model="isSidebarOpen"
            id="sidebar-right"
            right
            backdrop
            shadow
            width="109em"
            backdrop-variant="dark"
            ref="editItem"
            no-close-on-backdrop
            @change="closeSidePanelCallback()"
        >
            <template #title>
                <div>
                    <strong id="sidebar-right___title__" v-html="modalTitle()"></strong>
                </div>
            </template>
            <div class="d-block">
                <form class="needs-validation mb-4" novalidate id="financePaymentForm">
                    <div class="row">
                        <div class="col-sm-12">
                            <h5 class="mb-3">Данные по оплате счета #{{editedItem.finance_id}}</h5>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-4" v-if="isCurrencyOperation">
                            <label>Оплачено в валюте</label>
                            <b-form-input
                                required
                                id="sum_payment"
                                type="text"
                                v-model="editedItem.sum_currency"
                                @keyup="changeCommasOnDots($event)"
                            ></b-form-input>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Оплачено в рублях</label>
                            <b-form-input
                                required
                                id="sum_payment"
                                type="text"
                                v-model="editedItem.sum"
                                @keyup="changeCommasOnDots($event)"
                            ></b-form-input>
                        </div>
                    </div>                        
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label>Дата оплаты</label>
                            <b-form-input
                                required
                                id="payment_datetime"
                                type="date"
                                v-model="editedItem.payment_datetime"
                            ></b-form-input>
                        </div>
                        <div class="form-group col-md-4">
                            <label>Внешний идентификатор для платежа</label>
                            <b-form-input
                                id="external_id"
                                type="text"
                                v-model="editedItem.external_id"
                            ></b-form-input>
                            <b-form-text id="input-live-help">Если есть, можно заполнить.</b-form-text>
                        </div>
                    </div>
                </form>
            </div>
            <template #footer>
                <div class="row align-items-center">
                    <div class="col d-flex flex-row-reverse">
                        <button class="btn btn-primary text-right" type="submit" @click="submitForm($event)">Сохранить<i class="fas fa-spinner fa-spin ml-1" v-if="savingProcess"></i></button>
                    </div>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<script>
    import {API_FINANCE_PAYMENTS} from "../../constants"

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        changeCommasOnDots,
    } from '../../mixins'

    const initialEditedItem = () => ({
        id: '',
        creator_user_id: '',
        finance_id: '',
        sum: '',
        sum_currency: '',
        external_id: '',
        payment_datetime: '',
        user: {}
    })

    export default {
        components: {
        },
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            changeCommasOnDots,
        ],
        props: {
            finance_id: { type: Number|String, required: false },
            isNeedCreate: { type: Boolean, required: false, default: true },        // If table needs create new element button
            isCurrencyOperation: { type: Boolean, required: false, default: false },// If operation in other currency than rubles
            additionalGetParameter: { type: String, required: false, default: '' }, // If we want to add something, for example, &order_id=10
            typeOfTableFilter: { type: String, required: false, default: '' },      // Type of filter for output: orders, services
            isNeedSubtotal: { type: Boolean, required: false, default: false },     // If table needs subtotal under line
            sumRubles: { type: Number|String, required: false, default: 0 },     // Visible only with isNeedSubtotal == true
        },
        data() {
            return {
                changeLoad: false,
                tableApiUrl: API_FINANCE_PAYMENTS,
                componentRefreshKey: 0,
            }
        },
        watch: {
            'items.data': {
                handler(value) {
                    this.updateParentData()
                },
                immediate: true,
                deep: true,
            }
        },
        mounted() {
            this.editedItem = initialEditedItem()
            this.initialAssign()
        },
        methods: {
            initialAssign() {
                if (this.finance_id) {
                    this.editedItem.finance_id = this.finance_id
                }
            },
            // calls from mixin before sidebaropened
            beforeSidebarOpenedCallback() {
                this.editedItem = initialEditedItem()
                this.initialAssign()
            },
            // calls from mixin on item save
            onCreatedOrUpdatedCallback() {
                this.isSidebarOpen = false
            },
            submitForm(event) {
                event.preventDefault()
                let form = document.getElementById("financePaymentForm")
                if (form.checkValidity() === false) {
                    event.preventDefault()
                    event.stopPropagation()
                    form.classList.add('was-validated')
                    return false
                }
                this.createOrUpdateItem()
            },
            onDeletedCallback() {
                this.componentRefreshKey++
                this.updateParentData()
            },
            allPaidSummer(field) {
                let sum = 0

                this.items.data.forEach((payment, index) => {
                    sum = parseFloat(sum) + parseFloat(payment[field])
                })

                return sum
            },
            noDebt() {
                if ((this.sumRubles > 0 && (this.sumRubles - this.allPaidSummer('sum')) > 0) || this.isCurrencyOperation) {
                    return true
                }

                return false
            },
            modalTitle() {
                let title = 'Добавление оплаты'
                if (this.editIndex > -1) {
                    title = 'Редактирование оплату #' + this.editedItem.id
                }

                return title
            },
            updateParentData() {
                this.$emit("updateParentData")
            }
        }
    }
</script>
